const generaterVariantIds = () => {
	const variantIds = document.querySelector("#variant-ids");
	const nameIds = document.querySelectorAll('[name="id"]');
	const productId = document.querySelector('[name="art-size"]');
	// let paintingVariantId = document.querySelector('#painting').value;
	let variants = [];

	variants.push(productId.value);

	const bundleVariants = document.querySelectorAll(".bundle-variants");
	if (bundleVariants.length > 0) {
		bundleVariants.forEach((variant) => {
			variants.push(variant.value);
		});
	}

	variantIds.value = variants.join("|");

	nameIds.forEach((id) => {
		id.value = productId.options[productId.selectedIndex].value;
	});
};

const setDropdownSelected = (target) => {
	let select = target.closest(".group").querySelector("select");
	let valueTitle;
	let selectSelectedViaData;

	if (target.dataset.frameType) {
		valueTitle = target.dataset.size + "-" + target.dataset.frameType;
		selectSelectedViaData = select.querySelector('option[data-title="' + valueTitle + '"]').value;
		select.value = selectSelectedViaData;
	} else {
		valueTitle = target.dataset.size;
		selectSelectedViaData = select.querySelector('option[data-title="' + valueTitle + '"]').value;
		select.value = selectSelectedViaData;

		// set atttribute selected
		select.setAttribute("selected", valueTitle);
		select.setAttribute("data-cmSize", target.dataset.sizecm);
	}
};

const triggerFrames = (target) => {
	const activeFrames = document.querySelectorAll(
		'.group.frame .dropdown-item[data-size="' + target.dataset.size + '"]',
	);
	const allFrames = document.querySelectorAll(".group.frame .dropdown-item");

	allFrames.forEach((frame) => {
		frame.classList.remove("active");
	});

	activeFrames.forEach((frame) => {
		frame.classList.add("active");
	});

	if (target.dataset.frameType == undefined) {
		// click first active frame for dropdown size
		activeFrames[0].click();
	}
	
	setInformation();
};

function onFrameSelect(target) {
	
	const frameWrapper = document.querySelectorAll(".frame-image-wrapper");
	const option = target.querySelector('.dropdown-item input[type="radio"]');

	if (frameWrapper) {
		frameWrapper.forEach((frame) => frame.classList.remove("selected"));

		if (target.querySelector(".frame-image-wrapper"))
			target.querySelector(".frame-image-wrapper").classList.add("selected");
		else frameWrapper[0].classList.add("selected");

		if (option) option.click();

	}
}

const setInformation = () => {
	const image = document.querySelector("#frame-image");
	const details = document.querySelector("#frame-details");
	const width = document.querySelector("#frame-width");
	const thickness = document.querySelector("#frame-size");
	const information = document.querySelector("#frame-information");

	const frame = document.querySelector('[name="frame"]');
	const size = document.querySelector('[name="art-size"]');

	let selectedFrame = frame.options[frame.selectedIndex];
	let selectedSize = size.options[size.selectedIndex];

	if (selectedFrame.dataset.image) {
		if (selectedFrame.dataset.frameType == "stretched" || selectedFrame.dataset.frameType == "unframed") {
			image.closest(".box-image").classList.add("cover");
		} else {
			image.closest(".box-image").classList.remove("cover");
		}
		image.setAttribute("src", selectedFrame.dataset.image);
	} else {
		image.setAttribute("src", "");
	}

	const mainPhoto = document.querySelector(
		".product__main .product__media-list .swiper-slide-active .product__media",
	);
	const mainPhotoMobile = document.querySelector(
		".product__media-wrapper--mobile .product__media-list .swiper-slide-active .product__media",
	);

	let frameThickness = 82;

	if (selectedFrame.dataset.coverThickness) {
		frameThickness = selectedFrame.dataset.coverThickness;
	}

	if (mainPhoto) {
		if (selectedFrame.dataset.cover) {
			mainPhoto.setAttribute(
				"style",
				"--image: url('" +
					selectedFrame.dataset.cover +
					"'); --border-radius: 0; --scale: ." +
					frameThickness +
					";",
			);
		} else {
			mainPhoto.setAttribute("style", "--image: url(''); --border-radius: 0px;");
		}
	}

	if (mainPhotoMobile) {
		if (selectedFrame.dataset.cover) {
			mainPhotoMobile.setAttribute(
				"style",
				"--image: url('" +
					selectedFrame.dataset.cover +
					"'); --border-radius: 0; --scale: ." +
					frameThickness +
					";",
			);
		} else {
			mainPhotoMobile.setAttribute(
				"style",
				"--image: url('" + selectedFrame.dataset.cover + "'); --border-radius: 0px;",
			);
		}
	}

	details.innerHTML = selectedFrame.dataset.type;
	width.innerHTML = selectedFrame.dataset.width;
	thickness.innerHTML = selectedFrame.dataset.thickness;
	information.innerHTML = selectedFrame.dataset.information;

	const artPrice = document.querySelector("#art-price");
	const framePrice = document.querySelector("#frame-price");

	framePrice.innerHTML = selectedFrame.dataset.framePrice;
	artPrice.innerHTML = selectedSize.dataset.totalPrice;

	const totalPrices = document.querySelectorAll("#total-price");
	let total =
		parseFloat(artPrice.innerHTML.replace("$", "").replace(",", "")) +
		parseFloat(framePrice.innerHTML.replace("$", "").replace(",", ""));

	totalPrices.forEach((totalPrice) => {
		totalPrice.innerHTML = "$" + total.toFixed(2);
	});

	const originalPrices = document.querySelectorAll(".original-price");
	//Original Price = $299.95 ÷ 0.70;
	let original = total / 0.70;
	originalPrices.forEach((originalPrice) => {
		originalPrice.innerHTML = "$" + original.toFixed(2);
	});

	setCheckoutInfo(selectedFrame);
};

function sizeTrigger(target) {
	target.closest(".dropdown").classList.remove("active");

	// set the selected
	const sizeActive = target.closest(".group").querySelector(".dropdown-selected");

	if (target.dataset.image != "") {
		if (target.dataset.frameType == "stretched" || target.dataset.frameType == "unframed") {
			sizeActive.classList.add("cover");
		} else {
			sizeActive.classList.remove("cover");
		}

		sizeActive.querySelector(".dropdown-image").innerHTML =
			'<img class="dropdown-image__img" src="' + target.dataset.image + '"/>';
	} else {
		sizeActive.querySelector(".dropdown-image").innerHTML = "No Image";
	}

	// const imageSize = `<span class="test 123 image-size__text">${target.querySelector("[image-size]")?.getAttribute("image-size")} —&nbsp;</span>`; original
	//const dropdownText = `<div class="dropdown-title_text dropdown-title_text-title">${formatDimensions(target.dataset.size, false)}</div>`;
	//console.log("target: ",target);

	
		
	const imageSize = `<span class="test 123 image-size__text">${target.dataset.title } —&nbsp;</span>`; 
	
	
	let frameDescription = "Framed";
	if (target.dataset.title == 'Unframed') {
		frameDescription = "Arrives rolled on a tube";
	} else if(target.dataset.title == 'Stretched'){
		frameDescription = "Arrives ready to hang";
	}
	
	const dropdownText = `<div class="dropdown-title_text dropdown-title_text-title">${frameDescription}</div>`;

	sizeActive.querySelector(".dropdown-title_text").innerHTML = `
			${imageSize} ${dropdownText}
		`;

	let dropdownComparePrice = '';
	if(target.dataset.compareprice){
		dropdownComparePrice = `<span class="dropdown-compareprice">${target.dataset.compareprice}</span>`
	}
	

	sizeActive.querySelector(".dropdown-price").innerHTML = `${dropdownComparePrice} <span>${target.dataset.price}</span>`;

	const dropdownTitleEls = document.querySelectorAll(".dropdown-list .dropdown-title_text");
	if (dropdownTitleEls) {
		dropdownTitleEls.forEach((title) => {
			title.innerHTML = `${formatDimensions(title.textContent, true)}`;
		});
	}

	setDropdownSelected(target);
	generaterVariantIds();
	triggerFrames(target);
	onFrameSelect(target);
	onOptionSelect(target);
}

document.addEventListener("DOMContentLoaded", function (event) {
	// click first step 1
	if (document.querySelectorAll(".dropdown.dropdown-sizes .dropdown-list .dropdown-item").length > 0) {
		document.querySelectorAll(".dropdown.dropdown-sizes .dropdown-list .dropdown-item")[0].click();
	}

	addPopularBadge();
});

document.addEventListener("click", function (event) {
	if (event.target.classList.contains("dropdown-selected_sizes")) {
		document.querySelectorAll(".dropdown-frames").forEach((dropdownFrame) => {
			dropdownFrame.classList.remove("active");
		});
	}

	if (event.target.classList.contains("dropdown-selected")) {
		if (event.target.classList.contains("dropdown-frames")) {
			document.querySelectorAll(".dropdown-sizes").forEach((dropdownSize) => {
				dropdownSize.closest(".dropdown").classList.remove("active");
			});
		}

		if (event.target.classList.contains("dropdown-sizes")) {
			document.querySelectorAll(".dropdown-frames").forEach((dropdownFrame) => {
				dropdownFrame.closest(".dropdown").classList.remove("active");
			});
		}

		if (event.target.closest(".dropdown").classList.contains("active")) {
			event.target.closest(".dropdown").classList.remove("active");
		} else {
			event.target.closest(".dropdown").classList.add("active");
		}
	}

	if (event.target.classList.contains("size-selector")) {
		console.log("target:", event.target.classList);
		if (!event.target.classList.contains("unframed") && !event.target.classList.contains("noScrollTop")){
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
		
		sizeTrigger(event.target);
		
	}

	if (event.target.classList.contains("frame-item")) {
		frameTrigger(event.target);
		
		
	}

	if (event.target.classList.contains("gallery-close")) {
		const gallery = document.querySelector("#gallery");
		const bodyEl = document.querySelector("body");

		gallery.classList.remove("active");
		bodyEl.classList.remove("active");
	}

	// ======= LD Custom Code ======= //
	if (event.target.classList.contains("size-guide__option")) {
		onOptionSelect(event.target);
	}
});

const stickyCheckout = () => {
	const sticky = document.querySelector("#sticky-checkout");
	if (sticky) {
		let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

		if (document.querySelector("#MainContent div.shopify-section")) {
			if (document.querySelector("#MainContent div.shopify-section").offsetTop <= currentScroll) {
				sticky.classList.add("active");
			} else {
				sticky.classList.remove("active");
			}
		}
	}
};

window.addEventListener("scroll", function (e) {
	stickyCheckout();
});

function frameSelectTrigger(thisValue) {
	const frames = document.querySelectorAll(".frame-item:not(.default)");

	for (var x = 0; x < frames.length; x++) {
		frames[x].classList.add("hidden");

		// framesSelect[x].querySelector('option[data-title="' + thisValue +'"]').value;
		// framesSelect[x].closest('.frame').querySelector('.frame-price').innerHTML = framesSelect[x].querySelector('option[data-title="' + thisValue +'"]').dataset.money;

		// framesSelect[x].closest('.frame').querySelector('.frame-compare-at-price').innerHTML = framesSelect[x].querySelector('option[data-title="' + thisValue +'"]').dataset.compare;
		// framesSelect[x].value = framesSelect[x].querySelector('option[data-title="' + thisValue +'"]').value;
	}

	let selectableFrames = document.querySelectorAll('.frame-item[data-selector="' + thisValue + '"]');

	for (var y = 0; y < selectableFrames.length; y++) {
		selectableFrames[y].classList.remove("hidden");
	}
}

document.addEventListener("DOMContentLoaded", function (event) {
	const firstActiveSizeSelector = document.querySelector(".dropdown-sizes.dropdown-selected");

	if (firstActiveSizeSelector) {
		frameSelectTrigger(firstActiveSizeSelector.dataset.selector);
		sizeTrigger(firstActiveSizeSelector);
	}

	// // with_frames
	// let artPrice = document.querySelector('#art-price .price-item');
	// let totalPrice = document.querySelector('#total-price');
	// // let totalPriceSticky = document.querySelector('#total-price-sticky');
	// let framePrice = document.querySelector('#frame-price');

	// if ( framePrice ) {
	//     artPrice = artPrice.innerText.replace('$','').replace(',','');
	//     framePrice = framePrice.innerText.replace('$','').replace(',','');

	//     totalPrice.innerHTML = '-';

	//     totalPrice.innerHTML = '$' + (
	//         ( parseFloat(artPrice) + parseFloat(framePrice) )
	//         * parseInt(document.querySelector('[name="quantity"]').value)
	//     );

	//     // totalPriceSticky.innerHTML = '-';

	//     // totalPriceSticky.innerHTML = '$' + (
	//     //     ( parseFloat(artPrice) + parseFloat(framePrice) )
	//     //     * parseInt(document.querySelector('[name="quantity"]').value)
	//     // );
	// }

	const tabNavButton = document.querySelectorAll(".tab-nav_button");
	const tabContentItem = document.querySelectorAll(".tab-content_item");

	for (var x = 0; x < tabNavButton.length; x++) {
		tabNavButton[x].addEventListener("click", function (e) {
			let tab = e.target.dataset.tab;

			for (var z = 0; z < tabNavButton.length; z++) {
				tabNavButton[z].closest("li").classList.remove("active");
			}

			for (var y = 0; y < tabContentItem.length; y++) {
				tabContentItem[y].classList.remove("active");
			}

			e.target.closest("li").classList.add("active");
			document.querySelector('.tab-content_item[data-tab="' + tab + '"').classList.add("active");
		});
	}

	if (document.querySelector(".my-slider")) {
		var slider = tns({
			container: ".my-slider",
			items: 1,
			slideBy: "page",
			autoplay: true,
			nav: false,
			preventScrollOnTouch: "auto",
			autoplay: false,
			autoplayButton: false,
			autoHeight: true,
			controlsText: [
				'<span class="slider-prev"><svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></span>',
				'<span class="slider-next"><svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></span>',
			],
			mouseDrag: true,
		});

		const mediaButtons = document.querySelectorAll(".product-thumbnail_button");
		const gallery = document.querySelector("#gallery");
		const bodyEl = document.querySelector("body");

		mediaButtons.forEach((button) => {
			button.addEventListener("click", (e) => {
				gallery.classList.add("active");
				bodyEl.classList.add("active");

				slider.goTo(e.target.dataset.index);
			});
		});
	}

	const header = document.querySelector(".shopify-section-header");
	const headerBar = document.querySelector("sticky-header") || document.querySelector("header") || header;
	const headerHeight = Math.min(headerBar.offsetHeight, 200);

	if (window.innerWidth > 750) {
		document.querySelector("#MainContent").style.marginTop = headerHeight + "px";
	}

	if (document.querySelector("#sticky-checkout .button")) {
		document.querySelector("#sticky-checkout .button").addEventListener("click", (e) => {
			// e.target.classList.add('loading');
			// document.querySelector('.product-form .product-form__submit.button').click();
		});
	}
});

const randomString = (length) => {
	return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join("");
};
class Bundle extends HTMLElement {
	constructor() {
		super();

		this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

		this.init();
	}

	init() {
		this.selectedFilter = [];

		this.submitBtn = this.querySelector("button.add-to-cart");

		this.quantity = this.querySelector(".quantity__input");

		if (this.submitBtn) {
			alert(234342);
			this.submitBtn.addEventListener("click", () => {
				this.querySelector(".loading__spinner").classList.remove("hidden");
				this.AddToCart();
			});
		}

		this.addToBoxBtn = this.querySelectorAll("button.add-to-box");

		for (var x = 0; x < this.addToBoxBtn.length; x++) {
			this.addToBoxBtn[x].addEventListener("click", (e) => {
				this.addToBox(e.target);
			});
		}

		this.filterTheBox = this.querySelectorAll("button.filter-the-box");

		this.filterTheBox.forEach((filterOption) => {
			filterOption.addEventListener("click", (e) => {
				this.addFilter(e.target);
			});
		});

		this.removeBtn = this.querySelectorAll(".bundle-remove");

		this.removeBtn.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				// e.target.closest('.cart-item').querySelector('.loading__spinner').classList.remove('hidden');
				console.log(e.target.dataset.bundleKeys);
				this.removeFromCart(e.target.dataset.bundleKeys);
			});
		});

		this.summarizedItem = [];
	}

	addFilter(target) {
		this.selectedFilter.push(target.dataset.filter);

		let bundleItem = document.querySelectorAll(`.bundle-item`);
		let itemFilter = "";
		let removeLastComma;
		let removeIndex;

		if (target.classList.contains("remove-from-box")) {
			target.classList.remove("remove-from-box");
			target.closest(".bundle-filter").classList.remove("active");

			bundleItem.forEach((item) => {
				// hide reset
				item.classList.remove("show");

				// remove filter item in array
				removeIndex = this.selectedFilter.indexOf(target.dataset.filter);

				if (removeIndex >= 0) {
					this.selectedFilter.splice(removeIndex, 1);
				}
			});
		} else {
			target.classList.add("remove-from-box");
			target.closest(".bundle-filter").classList.add("active");

			bundleItem.forEach((item) => {
				removeLastComma = item.dataset.filter.slice(0, -1);
				itemFilter = removeLastComma.split(",");

				itemFilter.forEach((filter) => {
					if (this.selectedFilter.includes(filter)) {
						item.classList.add("show");
					}
				});
			});
		}

		let minimum = parseInt(target.closest(".tab-content").dataset.minimum);

		if (minimum == 0) {
			target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = false;
			target.closest(".tab-content").querySelector(".tab-arrow_next").classList.remove("disabled");
		} else {
			if (target.closest(".tab-content").querySelectorAll(".bundle-filter.active").length >= minimum) {
				target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = false;
				target.closest(".tab-content").querySelector(".tab-arrow_next").classList.remove("disabled");

				for (
					var bi = 0;
					bi < target.closest(".tab-content").querySelectorAll(".bundle-filter:not(.active)").length;
					bi++
				) {
					target
						.closest(".tab-content")
						.querySelectorAll(".bundle-filter:not(.active) .filter-the-box")
						[bi].classList.add("disabled");
					target.closest(".tab-content").querySelectorAll(".bundle-filter:not(.active) .filter-the-box")[
						bi
					].disabled = true;
				}
			} else {
				target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = true;
				target.closest(".tab-content").querySelector(".tab-arrow_next").classList.add("disabled");
				for (
					var bi = 0;
					bi < target.closest(".tab-content").querySelectorAll(".bundle-filter:not(.active)").length;
					bi++
				) {
					target
						.closest(".tab-content")
						.querySelectorAll(".bundle-filter:not(.active) .filter-the-box")
						[bi].classList.remove("disabled");
					target.closest(".tab-content").querySelectorAll(".bundle-filter:not(.active) .filter-the-box")[
						bi
					].disabled = false;
				}
			}
		}

		const allBundles = document.querySelectorAll(".bundle-item .add-to-box");

		// reset all bundle item
		allBundles.forEach((item) => {
			item.classList.remove("remove-from-box");
			item.closest(".bundle-item").classList.remove("active");
			item.closest(".bundle-item").querySelector("select").disabled = false;
			item.innerHTML = "Add to box";
			item.disabled = false;
			item.classList.remove("disabled");
			item.closest(".tab-content").querySelector(".tab-arrow_next").disabled = true;
			item.closest(".tab-content").querySelector(".tab-arrow_next").classList.add("disabled");
		});

		this.generateSummary();
	}

	addToBox(target) {
		if (target.classList.contains("remove-from-box")) {
			target.classList.remove("remove-from-box");
			target.closest(".bundle-item").classList.remove("active");
			target.closest(".bundle-item").querySelector("select").disabled = false;
			target.innerHTML = "Add to box";
		} else {
			target.classList.add("remove-from-box");
			target.closest(".bundle-item").classList.add("active");
			target.closest(".bundle-item").querySelector("select").disabled = true;
			target.innerHTML = "Remove from box";
		}

		let minimum = parseInt(target.closest(".tab-content").dataset.minimum);

		if (minimum == 0) {
			target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = false;
			target.closest(".tab-content").querySelector(".tab-arrow_next").classList.remove("disabled");
		} else {
			if (target.closest(".tab-content").querySelectorAll(".bundle-item.active").length >= minimum) {
				target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = false;
				target.closest(".tab-content").querySelector(".tab-arrow_next").classList.remove("disabled");

				for (
					var bi = 0;
					bi < target.closest(".tab-content").querySelectorAll(".bundle-item:not(.active)").length;
					bi++
				) {
					target
						.closest(".tab-content")
						.querySelectorAll(".bundle-item:not(.active) .add-to-box")
						[bi].classList.add("disabled");
					target.closest(".tab-content").querySelectorAll(".bundle-item:not(.active) .add-to-box")[
						bi
					].disabled = true;
				}
			} else {
				target.closest(".tab-content").querySelector(".tab-arrow_next").disabled = true;
				target.closest(".tab-content").querySelector(".tab-arrow_next").classList.add("disabled");
				for (
					var bi = 0;
					bi < target.closest(".tab-content").querySelectorAll(".bundle-item:not(.active)").length;
					bi++
				) {
					target
						.closest(".tab-content")
						.querySelectorAll(".bundle-item:not(.active) .add-to-box")
						[bi].classList.remove("disabled");
					target.closest(".tab-content").querySelectorAll(".bundle-item:not(.active) .add-to-box")[
						bi
					].disabled = false;
				}
			}
		}

		let summary = document.querySelectorAll(".bundle-item.active");

		let summaryItems = "";
		let summaryTitle = "";
		let summaryPrice = "";
		let summaryImage = "";
		let summaryValue = 0;

		for (var s = 0; s < summary.length; s++) {
			summaryTitle =
				"<br />(" +
				summary[s].querySelector("select").options[summary[s].querySelector("select").selectedIndex].dataset
					.title +
				")";

			if (summaryTitle == "<br />(Default Title)") {
				summaryTitle = "";
			}

			summaryImage = summary[s].querySelector("img").getAttribute("src");

			summaryPrice =
				summary[s].querySelector("select").options[summary[s].querySelector("select").selectedIndex].dataset
					.price;

			if (summary[s].classList.contains("hide-price")) {
				summaryPrice = "";
			}

			summaryValue =
				parseFloat(
					summary[s].querySelector("select").options[summary[s].querySelector("select").selectedIndex].dataset
						.value,
				) + parseFloat(summaryValue);

			summaryItems += `<li>
                <div class="grid--flex gap">
                    <img src="${summaryImage}" width="100"/>
                    <span>
                        ${summary[s].querySelector(".title").innerHTML}
                        ${summaryTitle}
                    </span>
                </div>
                <div>
                    ${summaryPrice}
                </div>
            </li>`;
		}

		document.querySelector("#bundle-box-content").innerHTML = summaryItems;

		document.querySelector("#bundle-box-subtotal span").innerHTML =
			summaryValue.toFixed(2) + " " + Shopify.currency.active;

		this.generateSummary();
	}

	generateSummary() {
		this.summarizedItem = [];

		const selectedFilters = this.querySelectorAll(".bundle-filter.active");

		selectedFilters.forEach((selectedFilter) => {
			this.summarizedItem.push({
				title: selectedFilter.dataset.value,
			});
		});

		const selectedBundles = this.querySelectorAll(".bundle-item.active");

		selectedBundles.forEach((selectedBundles) => {
			this.summarizedItem.push({
				title: selectedBundles.querySelector(".title").textContent,
				image: selectedBundles.querySelector("img").getAttribute("src"),
			});
		});

		let summaryItem = "";
		let summaryItemImage = "";

		this.summarizedItem.forEach((item) => {
			if (item.image) {
				summaryItemImage = '<img src="' + item.image + '" />';
			}

			summaryItem += `<li>${summaryItemImage}${item.title}</li>`;
		});

		const elsummary = document.querySelectorAll(".summary");

		elsummary.forEach((summary) => {
			summary.innerHTML = summaryItem;
		});
	}

	cartBubble(count) {
		document.querySelector("#cart-icon-bubble").innerHTML = `
        <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
            <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
        </svg>
        <span class="visually-hidden">Cart</span>
        <div class="cart-count-bubble">
            <span aria-hidden="true">${count}</span>
            <span class="visually-hidden">${count} items</span>
        </div>`;
	}

	async refreshCart(reOpenCart) {
		let cartCount = 0;
		try {
			const resCart = await fetch(`${routes.cart_url}.js`);
			const dataCart = await resCart.json();

			if (resCart.ok) {
				cartCount = dataCart.item_count;
				this.cartBubble(dataCart.item_count);
			}

			const res = await fetch(`${routes.cart_url}?view=ajax`);
			const data = await res.text();

			if (res.ok) {
				document.querySelector(".drawer__inner").innerHTML = data;

				if (cartCount == 0) {
					document.querySelector("cart-drawer").classList.add("is-empty");
				} else {
					document.querySelector("cart-drawer").classList.remove("is-empty");
				}
			}

			if (resCart.ok && res.ok) {
				if (reOpenCart == true) {
					this.cart.open();
					this.submitBtn.querySelector(".loading__spinner").classList.add("hidden");
					// this.submitBtn.querySelector('span').innerHTML = "Buy Another One";
				}
			}
		} catch (err) {
			console.log(err);
		}
	}

	AddToCart() {
		let items = [];
		let tempItems = [];

		let variantIds = document.querySelectorAll(".bundle-item.active select");

		if (variantIds.length == 0) return;

		let props = {};
		let selectedVariants = "";
		for (var q = 0; q < this.quantity.value; q++) {
			props = {
				ID: randomString(6),
			};

			for (var x = 0; x < variantIds.length; x++) {
				if (variantIds[x].value) {
					items.push({
						id: variantIds[x].value,
						quantity: 1,
						properties: props,
					});

					tempItems.push({
						id: variantIds[x].value,
						quantity: 1,
						properties: props,
					});
				}
			}

			selectedVariants = tempItems.map(({ id }) => id).join("|");

			props._bundleVariants = selectedVariants;

			tempItems = [];
		}

		let formData = {
			items: items,
		};

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((response) => response.json())
			.then((response) => {
				// reset Id
				props = {
					_bundleUniqueID: randomString(6),
				};

				this.refreshCart(true);
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	removeFromCart(items) {
		let variants = items.split(",");

		if (!variants) return;
		let obj = variants.reduce((o, key) => ({ ...o, [key]: 0 }), {});

		fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ updates: obj }),
		})
			.then((response) => response.json())
			.then((response) => {
				if (document.querySelector(".template-cart")) {
					location.reload();
				} else {
					location.reload();
					// this.refreshCart();
				}
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}
}

customElements.define("product-bundle", Bundle);

// function frameTrigger(target) {

//     document.querySelectorAll('.dropdown-frames').forEach(dropdownFrame => {
//         dropdownFrame.closest('.dropdown').classList.remove('active')
//     });

//     document.querySelector('.frame-item.active').classList.remove('active');

//     let frameImage = target.dataset.frameImage;

//     const frame = document.querySelectorAll('.frame');

//     for (var x = 0; x < frame.length; x++) {
//         frame[x].classList.remove('active');
//     }

//     target.classList.add('active');

//     const mainPhoto = document.querySelector('.product__main .product__media-list .swiper-slide-active .product__media');
//     const mainPhotoMobile = document.querySelector('.product__media-wrapper--mobile .product__media-list .swiper-slide-active .product__media');

//     let thickness = 82;

//     if ( target.dataset.thickness ) {
//         thickness = target.dataset.thickness
//     }

//     if ( mainPhoto ) {
//         if ( frameImage != '') {
//             mainPhoto.setAttribute('style', "--image: url('" + frameImage + "'); --border-radius: 0; --scale: ." + thickness + ";");
//         } else {
//             mainPhoto.setAttribute('style', "--image: url('" + frameImage + "'); --border-radius: 0px;");
//         }
//     }

//     if ( mainPhotoMobile ) {
//         if ( frameImage != '') {
//             mainPhotoMobile.setAttribute('style', "--image: url('" + frameImage + "'); --border-radius: 0; --scale: ." + thickness + ";");
//         } else {
//             mainPhotoMobile.setAttribute('style', "--image: url('" + frameImage + "'); --border-radius: 0px;");
//         }
//     }

//     let image = document.querySelector('#frame-image');
//     let details = document.querySelector('#frame-details');
//     let width = document.querySelector('#frame-width');
//     let size = document.querySelector('#frame-size');
//     let information = document.querySelector('#frame-information');
//     let framePrice = document.querySelector('#frame-price');
//     let frameComparePrice = document.querySelector('#frame-compare');
//     let artPrice = document.querySelector('#art-price .price-item');
//     let totalPrice = document.querySelector('#total-price');
//     // let totalPriceSticky = document.querySelector('#total-price-sticky');

//     image.setAttribute('src','');
//     details.innerHTML = '-';
//     width.innerHTML = '-';
//     size.innerHTML = '-';
//     information.innerHTML = '-';

//     framePrice.innerHTML = '$0';
//     frameComparePrice.innerHTML = '';

//     if ( target.dataset.image ) {
//         image.setAttribute('src', target.dataset.selectedImage);
//     }

//     if ( target.dataset.details ) {
//         details.innerHTML = target.dataset.details;
//     }

//     if ( target.dataset.width ) {
//         width.innerHTML = target.dataset.width;
//     }

//     if ( target.dataset.size ) {
//         size.innerHTML = target.dataset.size;
//     }

//     if ( target.dataset.information ) {
//         information.innerHTML = target.dataset.information;
//     }

//     if ( target.querySelector('select option:checked') ) {
//         framePrice.innerHTML = target.querySelector('select option:checked').dataset.money;
//         frameComparePrice.innerHTML = target.querySelector('select option:checked').dataset.compare;
//     }

//     artPrice = artPrice.innerText.replace('$','').replace(',','');;
//     framePrice = framePrice.innerText.replace('$','').replace(',','');;

//     totalPrice.innerHTML = '-';

//     totalPrice.innerHTML = '$' + (
//         ( parseFloat(artPrice) + parseFloat(framePrice) )
//         * parseInt(document.querySelector('[name="quantity"]').value)
//     );

//     // totalPriceSticky.innerHTML = '-';

//     // totalPriceSticky.innerHTML = '$' + (
//     //     ( parseFloat(artPrice) + parseFloat(framePrice) )
//     //     * parseInt(document.querySelector('[name="quantity"]').value)
//     // );

//     // set selected frame
//     const selectedFrame = document.querySelector('.dropdown-selected.dropdown-frames');

//     selectedFrame.querySelector('.frame-image img').setAttribute('src', target.dataset.selectedImage);
//     selectedFrame.querySelector('.dropdown-title_text').innerHTML = target.dataset.frameTitle
//     selectedFrame.querySelector('.dropdown-price').innerHTML = target.dataset.framePrice

//     // set selected stick checkout

//     // const StickyselectedFrame = document.querySelector('.sticky-options_option .dropdown-selected.dropdown-frames');
//     // StickyselectedFrame.querySelector('.frame-image img').setAttribute('src', target.dataset.selectedImage);
//     // StickyselectedFrame.querySelector('.dropdown-title_text').innerHTML = target.dataset.frameTitle
//     // StickyselectedFrame.querySelector('.dropdown-price').innerHTML = target.dataset.framePrice
// }

// if ( event.target.classList.contains('dropdown-selected_sizes') ) {
//     console.log(1234);
//     document.querySelectorAll('.dropdown-frames').forEach(dropdownFrame => {
//         dropdownFrame.classList.remove('active');
//     });
// }

// ====== LD Custom ====== //

function setCheckoutInfo(selectedFrame) {
	// Checkout button group
	const frameTitles = document.querySelectorAll(".floating__frame-title");
	const dataTitles = document.querySelectorAll(".floating__data-size");

	if (frameTitles) {
		frameTitles.forEach((frameTitle) => {
			let frameDescription = "Framed";
			if (selectedFrame.dataset.frameType.split("-")[0] == 'unframed') {
				frameDescription = "Arrives rolled on a tube";
			} else if(selectedFrame.dataset.frameType.split("-")[0] == 'stretched'){
				frameDescription = "Arrives ready to hang";
			}
			frameTitle.innerHTML = `${selectedFrame.dataset.frameType.split("-")[0]} - ${frameDescription}`;
		});
	}
	//console.log("setCheckoutInfo: ",selectedFrame);
	const sizeInput = document.querySelector('input[name="size-guide__option"]:checked');
	const sizeMetric = sizeInput && sizeInput.value === "inch" ? "in" : "cm";
	if (dataTitles) {
		dataTitles.forEach((dataTitle) => {
			dataTitle.innerHTML = `${formatDimensions(selectedFrame.dataset.fulltitle, true,sizeMetric)}`;
		});
	}
	
}

function formatDimensions(dimString, showDimType = true, metric = "inch") {
	const parts = dimString.split("📏");

	//console.log("parts: ",parts);

	let inchText = "";
	let cmText = "";

	const firstPart = parts[0] ? parts[0].trim() : ""; // Part before 📏
	const secondPart = parts[1] ? parts[1].trim() : ""; // Part after 📏

	if (firstPart) {
		const inchMatch = firstPart.match(/(\d+)-w-(\d+)-h(?:-\w+)?|(\d+)'' W × (\d+)'' H/);

		if (inchMatch) {
			const widthInch = inchMatch[1] || inchMatch[3]; // Match hyphenated or traditional width
			const heightInch = inchMatch[2] || inchMatch[4]; // Match hyphenated or traditional height
			inchText = `${widthInch}" x ${heightInch}" ${showDimType ? "in" : ""}`;
		}
	}

	// Check for centimeter dimensions (e.g., "61-50-8-cm" or "61 × 50.8 cm")
	if (secondPart) {
		const cmMatch = secondPart.match(/(\d+(-\d+)+)-cm(?:-\w+)?|(\d+(\.\d+)?) × (\d+(\.\d+)?) cm/);

		if (cmMatch) {
			const cmDimensions = cmMatch[1] ? cmMatch[1].replace(/-/g, " x ") : `${cmMatch[3]} x ${cmMatch[5]}`;
			cmText = `${cmDimensions} ${showDimType ? "cm" : ""}`;
		}
	}

	const result = metric === "inch" || metric === "in" ? inchText : cmText;

	return result || dimString;
}

function onOptionSelect(target) {
	const selectedTitle = document.querySelector(
		".dropdown.dropdown-sizes .dropdown-selected .dropdown-title_text > .dropdown-title_text",
	);
	const selectedValue = document.querySelector("select[selected]").getAttribute("selected");
	const sizeInput = document.querySelector('input[name="size-guide__option"]:checked');
	const sizeMetric = sizeInput && sizeInput.value === "inch" ? "in" : "cm";

	const selectedValueCM = document.querySelector("select[selected]").dataset.cmsize;
	//console.log("selectedValueCM: ",selectedValueCM);

	//console.log("selectedValue: ",selectedValue);
	selectedTitle.innerHTML = selectedValue && formatDimensions(selectedValueCM, true, sizeMetric);

	//for floating add to cart
	const floatingFrameSize = document.querySelector(".floating__data-size");
	floatingFrameSize.innerHTML = selectedValue && formatDimensions(selectedValueCM, true, sizeMetric);

	const titles = document.querySelectorAll(".dropdown-sizes .dropdown-list .dropdown-title_text");

	if (titles.length > 0) {
		titles.forEach((title) => {
			let parentElement = title.parentElement?.parentElement;
			let imageSize = parentElement?.querySelector(".dropdown-image__img")?.getAttribute("image-size");

			const dataSize = title.closest("button.dropdown-item")?.getAttribute("data-size");
			const dataSizeCM = title.closest("button.dropdown-item")?.getAttribute("data-sizecm");
			//console.log("dataSizeCM: ",dataSizeCM);
			if (dataSize) {
				title.innerHTML = `
					<span class="image-size__text">${imageSize || ""} —&nbsp;</span>
					<div class="dropdown-title_text dropdown-title_text-title">${formatDimensions(dataSizeCM, false, sizeMetric)} ${sizeMetric}</div>
				`;
			}
		});
	}
}

function addPopularBadge() {
	const dropdownItems = document.querySelectorAll(".dropdown-frames--mobile .dropdown-item.active");
	let found = false;

	// Add "Popular" badge to the first item with "minimalist" frame type
	dropdownItems.forEach((item) => {
		if (!found && item.getAttribute("data-frame-type").includes("classic")) {
			item.querySelector(".frame-image-wrapper").classList.add("badge--popular-mobile");
			found = true;
		}
	});

	// Add "Popular" badge to the dropdown item with "Medium" image size
	const selector = document.querySelector('select[name="art-size"]');
	if (selector) {
		const mediumItem = selector.parentElement.querySelector('[image-size="Medium"]')?.closest(".dropdown-item");
		if (mediumItem) {
			mediumItem.querySelector(".dropdown-title > .dropdown-title_text").classList.add("badge--popular");
		}
	}
}

